import { gql } from "@outschool/ui-apollo";

export const addDonationItemToOrderMutation = gql`
  mutation AddDonationItemToOrder($donationInput: DonationInput!) {
    addDonationItemToOrder(donationInput: $donationInput) {
      orderSlugId
      amountCents
    }
  }
`;
